import axios from 'axios';
import { eventHub } from '../../config/eventhub';
import { signOut } from '@/utils/auth';

const unauthorizedStatus = [401, 403];

export default function setup() {
  axios.interceptors.request.use(
    (config) => {
      eventHub.$emit('before-request');
      // Automatically authorize request headers with jwtToken
      const { idToken } = JSON.parse(localStorage.getItem('Exporo.Auth.SignedInUser')).signInUserSession;

      if (idToken) {
        config.headers.Authorization = `Bearer ${idToken.jwt}`;
      }

      return config;
    },
    (error) => {
      eventHub.$emit('request-error');

      return Promise.reject(error);
    },
  );

  // Add a response interceptor
  axios.interceptors.response.use((response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger

    // Check for response for Forbidden and or Unauthorized codes to send user to login page
    if (unauthorizedStatus.includes(response.status)) {
      signOut();
    }

    eventHub.$emit('after-response');

    return response;
  }, (error) => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Check for response for Forbidden and or Unauthorized codes to send user to login page
    if (error && error.response && unauthorizedStatus.includes(error.response.status)) {
      signOut();
    }
    // Do something with response error
    eventHub.$emit('response-error');

    return Promise.reject(error);
  });

  return axios;
}



// WEBPACK FOOTER //
// ./src/helpers/interceptors.js